import * as React from "react";
export function SvgSpacesSmallFlow(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={18} height={18} {...props}>
      <path
        d="M9 8h6c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1H9c-.6 0-1 .4-1 1v1H6c-.3-1.1-1.3-2-2.5-2C2.1 3 1 4.1 1 5.5S2.1 8 3.5 8c.2 0 .3 0 .5-.1l4 4.8V14c0 .6.4 1 1 1h6c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1H9c-.6 0-1 .4-1 1v.1L5 7.5c.5-.3.8-.9 1-1.5h2v1c0 .6.4 1 1 1zm6-4v3H9V4h6zm0 7v3H9v-3h6zM3.5 7C2.7 7 2 6.3 2 5.5S2.7 4 3.5 4 5 4.7 5 5.5 4.3 7 3.5 7z"
        fill="#676767"
      />
    </svg>
  );
}
